import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top on every route (pathname) change. react-router
 * preserves the previous scroll position by default, so navigating from a
 * scrolled-down list (e.g. the demo category cards) to a new route would
 * otherwise land you mid-page. In-page anchors (`#hash`) are left alone.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
